<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--Buttons-->
	<div class="button-body flex">
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onAdd()">Add Activation</button>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onEdit()">Edit Activation</button>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onDebugQR()">Debug QR Code</button>
		<button [disabled]="IsLoading() == true" class="btn btn-primary" style="margin-left: 5px" (click)="onDeactivate()">
			{{ ToggleText }}
		</button>
		<button [disabled]="IsLoading() == true" class="btn btn-danger" style="margin-left: 5px" (click)="onDelete()">Delete School</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstSchool"
		[loading]="IsLoading() == true"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedSchool"
		dataKey="SchoolID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--SchoolFullName-->
				<th>
					<p-columnFilter type="text" field="SchoolFullName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--AvailableCount-->
				<th>
					<p-columnFilter type="text" field="AvailableCount" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--TotalCount-->
				<th>
					<p-columnFilter type="text" field="TotalCount" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--ActiveDesc-->
				<th>
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActiveDesc
								[ngModel]="value"
								[options]="lstActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="SchoolFullName">School<p-sortIcon field="SchoolFullName"></p-sortIcon></th>
				<th pSortableColumn="AvailableCount">Available Count<p-sortIcon field="AvailableCount"></p-sortIcon></th>
				<th pSortableColumn="TotalCount">Total Count<p-sortIcon field="TotalCount"></p-sortIcon></th>
				<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-School>
			<tr [pSelectableRow]="School" (dblclick)="onRowDblClick(School)">
				<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ School[col.field] }}
				</td>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word" [style.color]="School.Active == true ? 'Black' : 'Red'">
					{{ School.ActiveDesc }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
